<template>
  <ls-search-form :formList="formList" @search="onSearch" ref="searchForm">
    <ls-select
      slot="factoryCode"
      v-decorator="['factoryCode']"
      :showSearch="true"
      placeholder="请选择"
      :options="selectSupplierList"
      :filter-option="filterOption"
      allowClear
      @search="handleSupplierSearch"
    />
    <lsSelectPage
      slot="dispatcherNo"
      v-decorator="['dispatcherNo']"
      :datas="dispatcherList"
      searchKey="dispatcher"
      valueKey="jobNo"
      placeholder="请选择"
    >
      <template slot="select-option" slot-scope="{items}">
        <a-select-option v-for="(i, index) in items" :key="index" :value="i.jobNo" :title="i.realName">
          {{ `${i.jobNo}-${i.realName}` }}
        </a-select-option>
      </template>
    </lsSelectPage>
  </ls-search-form>
</template>
<script>

import { apiGetDispatchList, apiGetsupplier } from '@/services/module/receiving-plan'
import moment from 'moment/moment'

export default {
  name: 'UnsatisfactoryListSearchForm',
  data () {
    return {
      dispatcherList: [],
      formList: [
        {
          label: "供应商",
          type: "factoryCode",
          decorator: ['factoryCode'],
          attrs: {
            placeholder: '请输入'
          }
        },
        {
          label: "要求到仓日期",
          type: "range",
          decorator: ['requireDeliveryTime'],
          disposeFormat: {
            requireDeliveryTimeStart: (change) => {
              return change[0].format('yyyy-MM-DD 00:00:00')
            },
            requireDeliveryTimeEnd: (change) => {
              return change[1].format('yyyy-MM-DD 23:59:59')
            }
          }
        },
        {
          label: "早晚班标识",
          type: "select",
          decorator: ['earlyMorningDeliveryIs'],
          options: [
            {
              value: '早班',
              key: 1
            },
            {
              value: '晚班',
              key: 0
            }
          ],
          attrs: {
            placeholder: "请输入"
          }
        },
        {
          label: "入库仓库",
          type: "select",
          decorator: ['warehouseName'],
          options: [
            {
              value: '佛山仓',
              key: '佛山仓'
            },
            {
              value: '青岛仓',
              key: '青岛仓'
            }
          ],
          attrs: {
            placeholder: "请输入"
          }
        },
        {
          label: "调度员",
          type: "dispatcherNo",
          decorator: ['dispatcherNo'],
          attrs: {
            placeholder: "请输入"
          }
        },
        // {
        //   label: "采购员编码",
        //   type: "input",
        //   decorator: ['purchaseUserNo'],
        //   attrs: {
        //     placeholder: "请输入"
        //   }
        // },
        {
          label: "采购员",
          type: "input",
          decorator: ['purchaseUserName'],
          attrs: {
            placeholder: "请输入"
          }
        },
        {
          label: "创建日期",
          type: "range",
          decorator: ['dataCreateTime'],
          disposeFormat: {
            dataCreateTimeStart: (change) => {
              return change[0].format('YYYY-MM-DD 00:00:00')
            },
            dataCreateTimeEnd: (change) => {
              return change[1].format('YYYY-MM-DD 23:59:59')
            }
          }
        }
      ],
      selectSupplierList: []
    }
  },
  methods: {
    // 手动输入
    filterOption (input, option) {
      return option.componentOptions.children[0].text.toLowerCase().trim().indexOf(input.toLowerCase().trim()) >= 0
    },
    onSearch(val) {
      val.purchaseUserName = val.purchaseUserName ? val.purchaseUserName?.trim() : undefined
      this.$emit('search', val)
    },
    getFormData() {
      return this.$refs.searchForm.getSearchValue()
    },
    handleSupplierSearch (val) {
      apiGetsupplier({ supplierQueryStr: val, page: 1, pageSize: 50 }).then(res => {
        const data = res?.data?.map(item => {
          return {
            value: item.companyCode,
            label: item.companyName
          }
        }) || []
        this.selectSupplierList = JSON.parse(JSON.stringify(data))
      })
    },
    // 获取调度组成员列表
    getDispatchList () {
      return new Promise(resolve => {
        apiGetDispatchList().then(res => {
          if (res.code === 200) {
            this.dispatcherList = res.rows.map(item => {
              return {
                ...item,
                dispatcher: `${item.jobNo}-${item.realName}`
              }
            })
            resolve(this.dispatcherList)
          }
        })
      })
    },
    setValueByDate() {
      this.$refs.searchForm.form.setFieldsValue({
        requireDeliveryTime: [moment().startOf('day').add('1', 'days'), moment().endOf('day').add('1', 'days')]
      })
    }
  },
  created() {
    this.handleSupplierSearch()
    this.getDispatchList()
  },
  activated() {
    this.setValueByDate()
  }
}
</script>
